import { render, staticRenderFns } from "./OutboxView.vue?vue&type=template&id=2740c4ee&"
import script from "./OutboxView.vue?vue&type=script&lang=js&"
export * from "./OutboxView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports